import { asyncMap } from './utils';
export const blobToHashedBlob = hasher => slicedBlob => hasher(slicedBlob.blob).then(hash => ({
  blob: slicedBlob.blob,
  hash: `${hash}-${slicedBlob.blob.size}`,
  partNumber: slicedBlob.partNumber
}));
export const hashinator = (blobs$, {
  hasher,
  concurrency
}) => asyncMap(blobToHashedBlob(hasher), concurrency)(blobs$);